export type BlogCategory = {
  categoryId: string;
  categoryName: string;
  categorySlug: string;
};

export type BlogAuthor = {
  name: string;
  designation?: string;
};

export type BlogArticle = {
  title: string;
  subtitle?: string;
  slug: string;
  date?: string;
  category: BlogCategory[];
  thumbnailUrl: string;
  bannerImageUrl: string;
  authors: BlogAuthor[];
  tags: string[];
  summary: string;
  description: string;
  similarPosts: string[];
  isRecent?: boolean;
  isFeatured?: boolean;
};

export type BlogVideo = {
  title: string;
  videoLink: string;
  createdOn?: string;
  seqNo: number;
  description?: string;
};

export type BlogArticleJson = {
  title: string;
  subtitle?: string;
  slug: string;
  date?: string;
  category?: Array<{
    categoryId?: string | number;
    categoryName?: string;
    categorySlug?: string;
  }>;
  thumbnail_url?: string;
  banner_image_url?: string;
  author?: BlogAuthor[];
  tags?: string[];
  summary?: string;
  description?: string;
  similar_posts?: string[];
  is_recent?: boolean;
  features?: boolean;
};

export type BlogVideoJson = {
  title: string;
  video_link: string;
  created_on?: string;
  seq_no?: number;
  description?: string;
};
